import { CourseExamEntity } from '../course-exam';
import { UserSummaryType } from '../../../../user/user-summary.type';
import {
  EnrollmentWithUserDb,
  ExamStudentEligibility,
} from '../exam-sessions-enrollment-entity';
import { BaseEntity } from '../../../../base-entity';

export interface ExamMetadata extends CourseExamEntity {
  sessions: ExamSessionEntity[];
}

export enum SessionType {
  FIRST_SESSION = 'first_session',
  SECOND_SESSION = 'second_session',
}

export interface ExamSessionEntity {
  id: number;
  examId: number;
  sessionDate?: Date;
  sessionType: SessionType;
  gradesApproval: boolean;
  registrationStartDate: Date;
  registrationEndDate: Date;
  notesCollected: boolean;
  averageGrade: number | null;
  createdAt: Date;
  createdBy: number;
  createdByName: string;
}

export interface StudentSessionRegistration {
  studentId: number;
  sessionId: number;
  examEligibility: ExamStudentEligibility;
  enrollment: boolean;
}

export interface ExamSessionFile extends BaseEntity {
  id: number;
  sessionId: number;
  fileUrl: string;
  fileName: string;
}

export interface ExamSessionDetails extends ExamSessionEntity {
  studentsRegistrations: StudentSessionRegistration[];
  classesSchedule: ClassSchedule[];
  files: ExamSessionFile[];
}

export interface LecturerWithActivityType extends UserSummaryType {
  activityTypeId: number;
  typeRateName: string;
}

export interface ClassSchedule {
  classId: number;
  className: string;
  scheduleId: number;
  startAt: Date;
  endAt: Date;
  protectors: LecturerWithActivityType[];
  enrollment: EnrollmentWithUserDb[];
}
